import { Money } from "../../utils/money";
import { DriverType } from "../delivery-company/drivers";
import { MerchantType } from "../delivery-company/merchants";
import { OrderType } from "../delivery-company/orders";
import { TotalAmounts } from "./invoice";

export enum MerchantOrdersInvoiceState {
    PENDING_PAYMENT = "PENDING_PAYMENT",
    PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
    COLLECTED_BY_DRIVER = "COLLECTED_BY_DRIVER",
    IN_PROGRESS = "IN_PROGRESS",
    AWAITING_RETURN = "AWAITING_RETURN",
    PAID = "PAID",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
}

export enum InvoicePaymentMethod {
    CASH = "CASH",
    WHISH = "WHISH"
}

export interface IMerchantOrdersInvoice {
    id: string;
    notes: string[];
    created_at: string;
    merchant: MerchantType | null,
    net_due_to_merchant: Money[];
    orders: OrderType[];
    packages: number;
    status: MerchantOrdersInvoiceState;
    payment_method: InvoicePaymentMethod;
}